import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { computed, reactive, watch, onMounted, ref } from "vue";
export default {
  props: ["questionInfo", "allAnswers"],
  setup(props, content) {
    //目录
    let menu = computed(() => {
      let list = [];
      let no = 0;
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        if (questionGroup.questionList[0].questionScore) {
          list.push(no + props.questionInfo.menu);
          no++;
        } else {
          list.push(null);
        }
      });
      return list;
    });
    //清洗文本
    let cleanQuestionList = computed(() => {
      let list = [];
      props.questionInfo.questionGroupList.forEach(questionGroupItem => {
        let text = questionGroupItem.questionList[0].questionStem;
        while (text.indexOf(">") != -1 && text.indexOf("<") != -1) {
          text = text.slice(0, text.indexOf("<")) + text.slice(text.indexOf(">") + 1);
        }
        text = text.replace(/&nbsp;/g, " ");
        //处理特殊字符
        text = text.split("");
        for (let i = 0; i < text.length; i++) {
          if (!(text[i] >= "a" && text[i] <= "z" || text[i] >= "A" && text[i] <= "Z" || text[i] >= 0 && text[i] <= 9 || text[i] == " " || text[i] == "-")) {
            text.splice(i + 1, 0, " ");
            text.splice(i, 0, " ");
            i += 2;
          }
        }
        text = text.join("").split(" ");
        for (let i = text.length - 1; i >= 0; i--) {
          if (text[i] == "" || text[i] == " ") {
            text.splice(i, 1);
          }
        }
        text = text.join(" ");
        list.push(text);
      });
      return list;
    });
    //答案
    let answer = reactive({});
    //操作展示
    let editRecord = computed(() => {
      let list = [];
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        if (questionGroup.questionList[0].questionId) {
          let data = {};
          data.id = questionGroup.questionList[0].questionId;
          if (answer[questionGroup.questionList[0].questionId]) {
            let answerText = answer[questionGroup.questionList[0].questionId];
            if (answerText.indexOf("<del>") != -1) {
              data.type = "del";
              data.text = answerText.slice(answerText.indexOf("<del>") + 5, answerText.indexOf("</del>"));
            } else if (answerText.indexOf("<u>") != -1) {
              data.type = "change";
              data.text = answerText.slice(answerText.indexOf("<span>") + 6, answerText.indexOf("</span>"));
            } else if (answerText.indexOf("<i>") != -1) {
              data.type = "insert";
              data.text = answerText.slice(answerText.indexOf("<span>") + 6, answerText.indexOf("</span>"));
            } else {
              data.type = "";
              data.text = "";
            }
          } else {
            data.type = "";
            data.text = "";
          }
          list.push(data);
        } else {
          list.push(null);
        }
      });
      return list;
    });
    watch(props, () => {
      let list = {};
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          if (questionItem.questionScore) {
            list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
          }
        });
      });
      Object.assign(answer, list);
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question")[0].scrollTop = 0;
    });
    //示例
    let examples = [{
      sentence: `Television is rapidly becoming the literature of our <span class="selecthighlight" style="border-bottom: 2px solid black; font-weight: bold;">periods.</span>`,
      answer: `period`,
      explain: `修改：选中要修改的<span class="selecthighlight">单词</span>，点“修改”按钮，把正确词填写在右侧横线上。`
    }, {
      sentence: `Many of the arguments <span class="selecthighlight" style="border-bottom: 2px solid black; font-weight: bold;user-select:none;">having</span> used for the study of literature as a`,
      answer: `<del>having</del>`,
      explain: `删除：选中要删除的<span class="selecthighlight">单词</span>，点“删除”按钮。`
    }, {
      sentence: `school subject are valid for <span class="ins" style="color: rgb(241, 163, 37); font-weight: bold; user-select: none;">∧</span>study of television.`,
      answer: `the`,
      explain: `  插入：在需要插入<span class="selecthighlight">单词</span>的空格处单击鼠标，点“插入”按钮，把插入词填写在右侧横线上。`
    }];
    function setAnswer() {
      content.emit("setAnswer", answer);
    }
    function setEditAnswer(msg) {
      let answerText = answer[msg.id];
      answer[msg.id] = answerText.slice(0, answerText.indexOf("<span>") + 6) + msg.text + answerText.slice(answerText.indexOf("</span>"));
      setAnswer();
    }
    let titleSwitch = ref(false);
    onMounted(() => {
      document.getElementsByClassName("question")[0].onscroll = function () {
        var scrollTop = document.getElementsByClassName("question")[0].scrollTop;
        if (scrollTop >= document.getElementsByClassName("answer-box")[0].offsetTop - 100) {
          document.getElementsByClassName("answer-box-title-out")[0].style.top = document.getElementsByClassName("question")[0].offsetTop + "px";
          document.getElementsByClassName("answer-box-title-out")[0].style.width = document.getElementsByClassName("answer-box-title")[0].offsetWidth + "px";
          titleSwitch.value = true;
        } else {
          titleSwitch.value = false;
        }
      };
    });
    let {
      setDom,
      modify,
      modifItem
    } = useModify(answer, setAnswer);
    return {
      titleSwitch,
      modifItem,
      examples,
      answer,
      setAnswer,
      menu,
      setDom,
      modify,
      editRecord,
      setEditAnswer,
      cleanQuestionList
    };
  }
};
function useModify(answer, setAnswer) {
  let modifItem = reactive({
    dom: null,
    text: "",
    id: null
  });
  //聚焦记录
  function setDom(e, text, id) {
    modifItem.dom = e.target;
    modifItem.text = text;
    modifItem.id = id;
  }
  //操作
  function modify(type) {
    if (!modifItem.dom) return 0;
    let startPos = window.getSelection().baseOffset || window.getSelection().anchorOffset; //anchorOffset 获取光标开始的位置
    let endPos = window.getSelection().extentOffset || window.getSelection().focusOffset; // focusOffset获取光标结束的位置
    if (startPos > endPos) {
      let no = startPos;
      startPos = endPos;
      endPos = no;
    }

    //删除
    if (type == "del") {
      if (answer[modifItem.id]) {
        return 0;
      }
      if (startPos == endPos) {
        modifItem.dom = null;
        modifItem.text = "";
        modifItem.id = null;
        return 0;
      }
      answer[modifItem.id] = modifItem.text.slice(0, startPos) + ` <del>${modifItem.text.slice(startPos, endPos)}</del> ` + modifItem.text.slice(endPos);
      setAnswer();
    }
    //修改(修改后的答案在 u span内)
    else if (type == "change") {
      if (startPos == endPos) {
        modifItem.dom = null;
        modifItem.text = "";
        modifItem.id = null;
        return 0;
      }
      answer[modifItem.id] = modifItem.text.slice(0, startPos) + ` <u>${modifItem.text.slice(startPos, endPos)}<span></span></u> ` + modifItem.text.slice(endPos);
    }
    // 插入(答案在 i span内
    else if (type == "insert") {
      answer[modifItem.id] = modifItem.text.slice(0, endPos) + ` <i><span></span></i>` + modifItem.text.slice(endPos);
    }
    //复原
    else {
      answer[modifItem.id] = "";
      modifItem.dom = null;
      modifItem.text = "";
      modifItem.id = null;
      setAnswer();
    }
    //清空记录
    modifItem.dom = null;
    modifItem.text = "";
    modifItem.id = null;
  }
  return {
    setDom,
    modify,
    modifItem
  };
}